import lottie from 'lottie-web';
import toArray from './../../scripts/to-array';

toArray(document.querySelectorAll('[data-component="animation"]')).forEach((component) => {
  const fileNames = component.dataset.fileName.split('|');
  const fileNamesIndex = Math.floor(Math.random() * fileNames.length);
  const path = `animations/${fileNames[fileNamesIndex]}.json`;

  const controller = lottie.loadAnimation({
    container: component,
    renderer: 'svg',
    loop: component.dataset.loop === 'true',
    autoplay: component.dataset.autoplay === 'true',
    path,
  });

  component.animationController = controller; // eslint-disable-line no-param-reassign

  if (component.dataset.lastframe === 'true') {
    controller.addEventListener('data_ready', () => {
      controller.goToAndStop(controller.totalFrames - 1, true);
    });
  }
});
